"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG = exports.LANGS = void 0;
const route_1 = require("../route");
exports.LANGS = route_1.PROJECT.sub("/langs");
exports.LANG = route_1.PROJECT.sub("/langs/:langId");
